
import React, { useState ,useEffect} from 'react';
import { Segment, Icon } from 'semantic-ui-react';
import Contact from './Contact';


const  PageMobileView = () =>{
return (
<div>
    
<Segment color='teal'><h2><Icon name="leaf"></Icon>Hygiene System</h2>
<br />
<img className="ui avatar image" src={require('./toilet12.jpg')}/>
<img className="ui avatar image" src={require('./toilet11.jpg')}/>
<img className="ui avatar image" src={require('./toilet13.jpg')}/>
<img className="ui avatar image" src={require('./toilet14.jpg')}/>
<img className="ui avatar image" src={require('./toilet15.jpg')}/>
<br />
<br />
is specialed on Hygenic toilet seats and toilet seat
covers.</Segment>
<Segment color='teal'><strong>BENEFITS</strong><br />
<Segment>Germs, meaning bacteria, virus, fungi, all of which are invisible to naked eye, can make you sick.
When you walk into a bathroom, you walk into a festival of germs.</Segment>
<Segment>
Touchless Hygiene Systems’ plastic sanitary covers will reduce your facilities’ cleaning cost by
saving from paper and cleaning product you go through every day.</Segment><Segment>Our seats also will reduce your cost of toilet paper since many people use toilet paper to make
a barrier between their skin and toilet seat.</Segment></Segment>
<Segment><strong>Convinient Seat Cover Roll Feature</strong><br/> Each cover contains 80 seat covers. Once the roll ends, the machine signals for
a change of a roll which is very ease.<Segment>The plastic cover starts to roll out a fresh seat with the help of a wall mounted touchless system
that comes with our seat. Once you wave your hand in front of the sensory system the machine
starts to work and in seconds you have your unused, fresh, hygienic seat.</Segment></Segment>
<Segment color='teal'> <Segment>We are a new company founded by three people with different backgrounds.</Segment>
<br />
<div id="mobile-founders">
<div className="ui horizontal list">
  <div className="item">
    <img className="ui avatar image" src={require('./person1.png')}/>
    <div className="content">
      <div className="header">Osman Yildirim</div>
      Founder & CEO
    </div>
  </div>
  <div className="item">
    <img className="ui avatar image" src={require('./person1.png')}/>
    <div className="content">
      <div className="header">Inan Temelkuran</div>
      Co-Founder & CFO
    </div>
  </div>
  <div className="item">
    <img className="ui avatar image" src={require('./person1.png')}/>
    <div className="content">
      <div className="header">Selcuk Koyuncu</div>
      Co-Founder & CTO
    </div>
  </div>
</div>
</div>
</Segment>




<div id="mobile-contact-container">
    <Contact view={"mobile"}/>
</div>



</div>)
}

export default PageMobileView;